
import React, { useEffect } from "react";
import {
    useLocation,
    useNavigate,
} from "react-router-dom";

export function LandingSectionScroll() {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname !== "/") return;

        const sectionId = location.state?.scrollTo;

        if (!sectionId) return;

        const frame = requestAnimationFrame(() => {
            document.getElementById(sectionId)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        });

        return () => cancelAnimationFrame(frame);
    }, [location]);

    return null;
}

export default function SectionLink({
    to,
    children,
    onClick,
    ...props
}) {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = (e) => {
        e.preventDefault();

        onClick?.(e);

        const sectionId = to.replace(/^#/, "");

        if (location.pathname === "/") {
            document.getElementById(sectionId)?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } else {
            navigate("/", {
                state: {
                    scrollTo: sectionId,
                },
            });
        }
    };

    return (
        <a
            href={`#${sectionIdFrom(to)}`}
            onClick={handleClick}
            {...props}
        >
            {children}
        </a>
    );
}

function sectionIdFrom(to) {
    return to.replace(/^#/, "");
}
